import React from 'react';
import Reflux from 'reflux';
import AppStore from '../AppStore';
import AppActions from '../AppActions';
import Comment from './Comment';
import './Comments.css';
import RcIf from 'rc-if';

class Comments extends Reflux.Component {
    constructor (props) {
        super(props);
        this.state = {
            globalTopic: this.props.globalTopic,
            comments: [
            ],
            comment: ''
        };
        this.handleSendComment = this.handleSendComment.bind(this);
        this.handleChangeComment = this.handleChangeComment.bind(this);
        this.store = AppStore;
    }
    handleSendComment () {
        if (this.state.comment !== '') {
            if (this.state.globalTopic) {
                AppActions.newComment({topic: this.state.currentTopic.global_title, comment: this.state.comment});
            } else {
                let topicId = this.state.currentTopic._id;
                AppActions.newComment({usertopic: topicId, comment: this.state.comment});
            }
        }
    }
    handleChangeComment (e) {
        let value = e.target.value;
        this.setState({comment: value});
    }
    componentWillReceiveProps (newProps) {
        if (newProps.globalTopic) {
            this.setState({globalTopic: newProps.globalTopic});
        } else {
            this.setState({globalTopic: false});
        }
    }
    render () {
        let comments = this.state.comments.map((comment) => {
            return <Comment key={comment._id} globalTopic={this.state.globalTopic} comment={comment} />;
        });
        return (<div className='row'>
          <div className='col s12'>
            <div className='clearfix' />
            <div className='spacetop' />
            <div className='box'>
              <h5><img className='iconComment' src='/images/icons/comment.png' />Comentarios <span>({this.state.comments.length})</span></h5>
              <div className='content-comment'>
                <textarea className='materialize-textarea' name='comentario' rows='1' value={this.state.comment} onChange={this.handleChangeComment} placeholder='Escribí tu comentario:' />
              </div>
              <div className='btn-send'>
                <input type='submit' value='Comentar' className='waves-effect waves-light' onClick={this.handleSendComment} />
              </div>
              <div className='row'>
                <ul className='foro-rta'>
                  {comments}
                </ul>
              </div>
              <RcIf if={this.state.loadMoreComments}>
                <div className='row center-align'>
                  <a className='btn-flat waves-effect waves-light plus-btn' onClick={() => { AppActions.getMoreComments(this.state.currentTopic._id); }}>
                    <img src='/images/icons/plus.svg' />
                  </a>
                </div>
              </RcIf>
            </div>
          </div>
        </div>);
    }
}

export default Comments;



// WEBPACK FOOTER //
// ./src/sections/Comments.js